import { useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import { useGetData } from "../../../hooks";
import { GetAllAdds } from "../../../interface/GeneralResponse";
import { EndPoints } from "../../../Constants/endpoints";
import { GeneralImage, Slider } from "../../../components";

const AdsCard = () => {
  const { data, isPending } = useGetData<GetAllAdds[]>(EndPoints.GetAllAds);
  const [currentSlide, setCurrentSlide] = useState(0);
  return (
    <>
      {isPending ? (
        <div className="bg-primary-bg w-full animate-pulse select-none rounded-lg" />
      ) : (
        <div
          className={`box max-sm:h-5 h-fit max-h-72 !w-full !p-4 ${data?.Data?.length === 0 && "hidden"}`}
        >
          <Slider
            getCurrentIndex={(currentIndex) => setCurrentSlide(currentIndex)}
            slides={data?.Data?.map((e, index) => (
              <GeneralImage
                src={e.Image}
                key={index}
                alt={e.Title}
                className="h-fit max-h-60 !w-full cursor-pointer !select-none rounded-lg object-fill max-sm:max-h-56"
                width="100%"
                withPreview
              />
            ))}
            autoSlide={true}
            autoSlideInterval={2000}
            customDot={(index) => (
              <div
                className={`${index == currentSlide ? "!w-12 !bg-primary" : ""} duration-800 bg-primary-40 h-1.5 w-1.5 cursor-pointer rounded-full transition-all`}
              />
            )}
          />
        </div>
      )}
    </>
  );
};

export default AdsCard;
